import { EditableTableCellSelectionState } from "./EditableTableCell";

const BORDER_STYLE = "1px solid #000";
const BORDER_STYLE_DASHED = "1px dashed var(--Gray-900, #0F1826)";

export function calculateCellBorders(
    selectionState: EditableTableCellSelectionState | undefined,
) {
    const borderStyle = selectionState?.isInBuffer
        ? BORDER_STYLE_DASHED
        : BORDER_STYLE;

    return {
        borderTop: selectionState?.top ? borderStyle : undefined,
        borderBottom: selectionState?.bottom ? borderStyle : undefined,
        borderLeft: selectionState?.left ? borderStyle : undefined,
        borderRight: selectionState?.right ? borderStyle : undefined,
    };
}
